export default __webpack_public_path__ + "static/media/GeorgeNormal.4279b8ed.jpg";